import { useEffect } from 'react';
import apiClient from '../services/apiClient';
import logger from '../core/logger/logger';
import { changeLanguage, getChosenLanguage } from './index';

export const i18nAPI = {
  /** [{code, name, nativeName, isDefault}] — активные языки (публичный эндпоинт) */
  languages: () => apiClient.get('/v1/i18n/languages', { silentError: true }).then((r) => r.data || []),
};

export const userLanguageAPI = {
  get: () => apiClient.get('/v1/users/language', { silentError: true }),
  /** language = код языка или null (следовать Telegram) */
  set: (language) => apiClient.put('/v1/users/language', { language }, { silentError: true }),
};

/**
 * После входа сверяет язык из Settings с сервером (`users.language` — на нём же бот пишет игроку):
 * на сервере выбран, а локально нет (новое устройство) → применяем серверный;
 * локально выбран, а на сервере нет → сохраняем на сервер.
 */
export function useLanguageSync(enabled) {
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await userLanguageAPI.get();
        if (cancelled) return;
        const server = data?.language || null;
        const local = getChosenLanguage();
        if (server && server !== local) {
          await changeLanguage(server, { persist: true });
        } else if (!server && local) {
          await userLanguageAPI.set(local);
        }
      } catch (e) {
        logger.warn('[i18n] language sync failed', { message: e?.message });
      }
    })();
    return () => { cancelled = true; };
  }, [enabled]);
}
